import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MeteringPointCalculationParameterDto } from '@app/api/dmc';
import { LucideAngularModule, Plus, Trash } from "lucide-angular";
import { AlertComponent } from '@shared/components/alert/alert.component';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { AlgorithmList } from '@shared/lists/algorithm-list';
import { SelectDirective } from '@shared/components/input/select/select.directive';

@Component({
  selector: 'app-calculation-form',
  imports: [
    AlertComponent,
    FormsModule,
    InputGroupComponent,
    LabelDirective,
    LucideAngularModule,
    ReactiveFormsModule,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './calculation-form.component.html',
  styleUrl: './calculation-form.component.css'
})

export class CalculationFormComponent implements OnInit {

  @Input() public form!: FormGroup;
  @Input() public rowHandler!: MeteringPointCalculationParameterDto[];
  @Input() public algorithmDynamic: boolean = false;

  public activeDescription?: string;
  public algorithmForholdsfordelt: boolean = false;

  public algorithmList = AlgorithmList;

  protected readonly Trash = Trash;
  protected readonly Plus = Plus;

  ngOnInit(): void {
    const control = this.form.get('calculationStructureInternalName') as FormControl;

    control.valueChanges.subscribe((value: string) => {
      if (!value) return;

      this.rowHandler.splice(0);

      const element = this.algorithmList.find(e => e.key === value);
      this.activeDescription = element?.description ?? '';

      this.algorithmDynamic = value === '=(MP1+MP2+[...])';
      this.algorithmForholdsfordelt = value === '=ShareDistribute(MP1;MP2;MP3+[...])';
      this.form.get('calculationStructureIsDynamic')?.setValue(this.algorithmDynamic || this.algorithmForholdsfordelt);

      if (this.algorithmForholdsfordelt) {
        this.rowHandler.push(
          { internalName: 'MP1', name: 'MP1 - Samlet Måling', meteringPointIdentification: '' },
          { internalName: 'MP2', name: 'MP2 - Målepunkts Egenmåling', meteringPointIdentification: '' },
        );
      } else {
        const count = this.getMaxMpNumber(value);
        if (count > 0) {
          this.addRow(count);
        }
      }
    });
  }

  public clearRow(): void {
    this.rowHandler.splice(0);
  }

  public addRow(count: number = 1): void {
    for (let i = 0; i < count; i++) {
      this.rowHandler.push({
        internalName: `MP${this.rowHandler.length + 1}`,
        meteringPointIdentification: ''
      });
    }
  }

  public removeRow(index: number): void {
    if (this.algorithmForholdsfordelt && index < 2) return;
    if (this.rowHandler[index]) {
      this.rowHandler.splice(index, 1);
    }
  }

  public getMaxMpNumber(expression: string): number {
    const matches = expression.match(/MP(\d+)/g);
    if (!matches) return 0;
    const numbers = matches.map(mp => parseInt(mp.replace('MP', ''), 10));
    return Math.max(...numbers);
  }
}
